import { useEffect } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import {
  getIsLoggedIn,
  getUsersLoadingStatus,
  loadUsersList,
} from "../../store/users";
import { loadSpecialtiesList } from "../../store/specialties";
import { loadGroupsList } from "../../store/groups";
import { loadLevelsList } from "../../store/levels";
import { loadDeletesList } from "../../store/delete";
import { loadInvitationList } from "../../store/invitations";
import { loadPaymentList } from "../../store/payment";
import { loadCountriesList } from "../../store/countries";
import { loadTownsList } from "../../store/towns";
import { loadSkillsList } from "../../store/skills";
import localStorageService from "../../service/http.localStorage";
import { useI18n } from "../../i18n/LanguageContext";

const AppLoader = ({ children }) => {
  const { t } = useI18n();
  const dispatch = useDispatch();
  const isLoggedIn = useSelector(getIsLoggedIn());
  const usersStatusLoading = useSelector(getUsersLoadingStatus());

  const currentCountry = localStorageService.getCountry();

  useEffect(() => {
    dispatch(loadSpecialtiesList());
    dispatch(loadLevelsList());
    dispatch(loadSkillsList());
    dispatch(loadCountriesList());
  }, []);
  useEffect(() => {
    dispatch(loadTownsList());
  }, []);

  useEffect(() => {
    if (isLoggedIn) {
      dispatch(loadUsersList());
      dispatch(loadGroupsList());
      dispatch(loadDeletesList());
      dispatch(loadPaymentList());
      dispatch(loadInvitationList());
    }
  }, [isLoggedIn]);

  if (usersStatusLoading)
    return (
      <div className="w-full h-screen">
        <p className="flex justify-center">{t("common.loading")}</p>
      </div>
    );
  return children;
};

AppLoader.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

export default AppLoader;
